import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const WrapperStyled = styled(Stack)(({ isDisable }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  opacity: isDisable ? 0.5 : 1
}));
